import {Component, Directive, Input} from '@angular/core';

import {MzRemoveComponentHost} from '../../shared';

@Component({
  selector: 'mz-collapsible-item',
  templateUrl: './collapsible-item.component.html',
  styleUrls: ['./collapsible-item.component.scss'],
})
export class MzCollapsibleItemComponent extends MzRemoveComponentHost {
  @Input() active: boolean;
}

@Directive({selector: 'mz-collapsible-item-body'})
export class MzCollapsibleItemBodyDirective {
}

@Directive({selector: 'mz-collapsible-item-header'})
export class MzCollapsibleItemHeaderDirective {
}
